import React from 'react';

import i18n from 'i18';

// @mui
import { TableCell } from '@mui/material';
import Label from '../../components/label';

// Text, Number, Items cells are similar
export default class GridBooleanCell extends React.Component {
    render() {
        const { value, field } = this.props;
        const { trueLabel = 'enabled', falseLabel = 'disabled' } = field;
        // const { trueLabel = 'enabled', falseLabel = 'disabled', requiredFields = [] } = field;
        // const isRequiredFieldsExist = requiredFields.every(f => value && value[f] !== null);
        // const displayValue = isRequiredFieldsExist && value;

        return (
            <TableCell key={field.id} align="left">
                <Label
                    color={value ? 'success' : 'error'}
                    sx={{ fontSize: 12 }}
                >
                    {i18n.t(`enums.${value ? trueLabel : falseLabel}`)}
                </Label>
            </TableCell>
        );
    }
}
